<template>
    <div class="full-width" ref="billDetailDom">
        <el-row :gutter="10">
            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="賬單單號">{{i18n.tkey("lang_bill_id")}}</span> : <span class="info-content">{{obj.commonref}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="賬單類型">{{i18n.tkey("lang_bill_order_type")}}</span> : <span class="info-content">{{orderType}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="下單者郵箱">{{i18n.tkey("lang_bill_email")}}</span> : <span class="info-content">{{obj.addinfo3}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="下單者姓名">{{i18n.tkey("lang_bill_username")}}</span> : <span class="info-content">{{obj.name}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="下單者電話">{{i18n.tkey("lang_bill_tel")}}</span> : <span class="info-content">{{obj.telephone}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="總金額">{{i18n.tkey("lang_bill_total")}}</span> : <span class="info-content">{{totalNum}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="支付單號">{{i18n.tkey("lang_pay_no")}}</span> : <span class="info-content">{{obj.orderno}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="支付狀態">{{i18n.tkey("lang_pay_state")}}</span> : <span class="info-content">{{orderPayState}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="支付時間">{{i18n.tkey("lang_pay_date")}}</span> : <span class="info-content">{{obj.orderdate}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="支付方式">{{i18n.tkey("lang_pay_method")}}</span> : <span class="info-content">{{payMethod}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="訂單狀態">{{i18n.tkey("lang_bill_state")}}</span> : <span class="info-content">{{orderState}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="下單日期">{{i18n.tkey("lang_order_date")}}</span> : <span class="info-content">{{obj.inputdate}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="審核通過時間">{{i18n.tkey("lang_verify_date")}}</span> : <span class="info-content">{{obj.verifydate}}</span>
            </el-col>
        </el-row>

        <div class="title-part">
            <span tkey="購買詳情">{{i18n.tkey("lang_buy_detail")}}</span>
        </div>

        <div>
            <billProductTable :boproducts="obj.boproducts" />
        </div>
    </div>
</template>

<script setup>
    import {ref, toRef, getCurrentInstance, onMounted, computed, inject} from 'vue'
    import billProductTable from "@/components/shopopee/bill/billProductTable"

    const props = defineProps(['obj'])

    const { proxy } = getCurrentInstance()

    const i18n = inject("i18n")

    const width = ref(425)
    const cols = ref(24)

    const totalNum = computed(() => {
        let curr = "HKD"

        if (null != props.obj.boproducts && props.obj.boproducts.length > 0){
            curr = props.obj.boproducts[0].curr
        }

        return `${props.obj.totalsum} ${curr}`
    })

    const orderState = computed(() => {
        let state = i18n.tkey("lang_under_review")  //審核中

        if (props.obj.verify == -1){
            state = i18n.tkey("lang_completed")
        }else if (props.obj.verify == 1){
            state = i18n.tkey("lang_refused")
        }

        return state
    })

    const payMethod = computed(() => {
        let name = ""

        if (props.obj.printout == 1){
            name = "paypal"
        }

        return name
    })

    const orderPayState = computed(() => {
        let payState = i18n.tkey("lang_unpaid")

        if (props.obj.completedpayment == -1){
            payState = i18n.tkey("lang_paid")
        }

        return payState
    })

    const orderType = computed(() => {
        let type = i18n.tkey("lang_company_auth")

        switch (props.obj.japno) {
            case "0":
                type = i18n.tkey("lang_company_auth");
                break;

            case "1":
                type = i18n.tkey("lang_staff_num");
                break;

            case "2":
                type = i18n.tkey("lang_three_shop_exp");
                break;

            case "3":
                type = i18n.tkey("lang_buy_nfc_card");
                break;

            case "4":
                type = i18n.tkey("lang_customer_bill");
                break;
        }

        return type
    })

    onMounted(() => {
        width.value = proxy.$refs.billDetailDom.offsetWidth

        if (width.value > 768){
            cols.value = 12
        }

    })

</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .title-part {
        text-align: left;
        margin-top: 20px;
        margin-bottom: 10px;
    }

    .info-parts {
        padding: 10px;
        text-align: left;
        font-size: 15px;
    }

    .info-title {
        color: #606266;
    }

    .info-content {
        color: #606266;
    }
</style>